/**
 * Handle Classes
 */
export default function () {
	const html = document.documentElement;
	const { fn: { debounce, getScrollBarWidth } } = am2;
	let lastScrollTop = 0;
	let isScrolling = false;

	html.classList.remove('no-js');
	html.classList.add('js');

	const getScrollTop = () => window.scrollY || html.scrollTop;

	const hasScrolled = () => html.classList.toggle('has-scrolled', getScrollTop() - (html.clientTop || 0) > 1);

	const onScrollEvt = () => {
		const st = getScrollTop();

		// Add `has-scrolled' class
		hasScrolled();

		// Add `is-scrolling` class
		if (!html.classList.contains('is-scrolling')) {
			html.classList.add('is-scrolling');
		}

		// Clear previous timeout - cleanup
		clearTimeout(isScrolling);
		isScrolling = setTimeout(() => {
			if (html.classList.contains('is-scrolling')) {
				html.classList.remove('is-scrolling');
			}
			clearTimeout(isScrolling);
		}, 500);

		lastScrollTop = st <= 0 ? 0 : st;

		if (lastScrollTop === 0) {
			html.classList.remove('is-scrolling');
			html.classList.remove('scrolling-down');
			html.classList.remove('scrolling-up');
		}
	};

	hasScrolled();
	window.onscroll = debounce(onScrollEvt, 10);

	const setScrollbarWidth = () => html.style.setProperty('--wp--scrollbar--width', `${getScrollBarWidth()}px`);

	setScrollbarWidth();
	window.onresize = debounce(setScrollbarWidth, 100);
}
document.addEventListener('DOMContentLoaded', function() {
    var scrollLinks = document.querySelectorAll('.scroll-to');

    scrollLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
            event.preventDefault(); // Prevent default link behavior

            // Attempt to find the next '.logo-slider' from the parent 'div'
            var parentDiv = link.closest('div.am2-slider'); // Find the closest parent 'div' of '.scroll-to'
            if (parentDiv) {
                var nextDiv = parentDiv.nextElementSibling; // Get the next sibling element which should be '.logo-slider'
                if (nextDiv) {
                    window.scrollTo({
                        top: nextDiv.offsetTop - document.querySelector('.wp-site-content').offsetTop - 88, // Adjust if there is a static header or offset
                        behavior: 'smooth'
                    });
                }
            }
        });
    });
});

